import { GlobalMyAccountFinHubRoutes } from '@hdms/shared/common-types';

export const FinHubModuleRoute = {
  QUOTES_MODULE: `/${GlobalMyAccountFinHubRoutes.BASE}/${GlobalMyAccountFinHubRoutes.QUOTES}`,
  ORDERS_MODULE: `/${GlobalMyAccountFinHubRoutes.BASE}/${GlobalMyAccountFinHubRoutes.ORDERS}`,
  CONSUMABLE_REPORTING_MODULE: `/${GlobalMyAccountFinHubRoutes.BASE}/${GlobalMyAccountFinHubRoutes.CONSUMABLE_REPORTING}`
};

export const FT_AM_ENABLED_FLAG = 'ldt_new_authorization_management';
export const FT_SOFTWARE_SELLING = 'ldt_software_selling';
export const FT_CCP_LINK = 'ldt_ccp_kr_link';
export const FT_JUMP_TO_BYD = 'ldt_jump_to_byd';
export const FT_CONSOPASS_REPORTING = 'ldt_consumables_subscription_reporting';
